import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  addeditdata
} from "../../../controllers/investors/investorController";
import { list as relManagerList } from "../../../controllers/relationshipManagers/relManagersController";
import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;

  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const listQuery = state?.listQuery;
  const investorData =
    state?.item !== undefined
      ? state.item
      : state && !state.listQuery
      ? state
      : {};
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(investorData);
  const [image, setImage] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const [relManagersList, setRelManagerList] = useState([]);
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    // setAddEditSata((pre) => ({
    //   ...pre,
    //   [e.target.name]: e.target.value,
    // }));
    const { name, value } = e.target;
    if (name === "rel_manager") {
      setAddEditSata((pre) => ({
        ...pre,
        [name]: JSON.parse(value),
      }));
    } else {
      setAddEditSata((pre) => ({
        ...pre,
        [e.target.name]: e.target.value,
      }));
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
  /*********************************************************
   *  This function is use to handle image
   *********************************************************/
  const handleImageChnage = (e) => {
    setImage(e.fileList);
  };

  const getRelManagersList = async () => {
      try {
        setRelManagerList([]);
        const options = {
          type: "",
          condition: { status: "A" },
          select: {},
          sort: {},
          skip: 0,
          limit: 0,
        };
        const listData = await relManagerList(options);
        if (listData.status === true) {
          if (listData.result.length > 0) {
            setRelManagerList(listData?.result);
          } else {
            setRelManagerList([]);
          }
        } else {
          setRelManagerList([]);
        }
      } catch (error) {
        console.log("error", error);
        setRelManagerList([]);
      }
    }; //End

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const { _id, investor_firm_name, investor_description, rel_manager } = ADDEDITDATA;
      const ipAddress = await fetchIpAddress();

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("investor_firm_name", investor_firm_name ? investor_firm_name : "");
      form.append("investor_description", investor_description ? investor_description : "");
      form.append("rel_manager", rel_manager ? rel_manager?._id : "");
      if (image.length > 0) {
        form.append("image", image[0]?.originFileObj);
      }

      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);

      if (isValidate) {
        const options = {
          url: "accounts/investors/addeditdata",
          postData: form,
        };
        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated!",
            description: `Data updated successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/investors/list", { state: { listQuery } });
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    if (!formData.get("investor_firm_name")) {
      setError((prevError) => ({
        ...prevError,
        investor_firm_name: "Firm name is required",
      }));
      return false;
    }
    // if (!formData.get("investor_description")?.trim() || formData.get("investor_description") === '' || formData.get("investor_description") === 'undefined') {
    //   setError((prevError) => ({
    //     ...prevError,
    //     investor_description: "Description is required",
    //   }));
    //   return false;
    // }
    return true;
  };

  useEffect(() => {
    getRelManagersList();
    document.title = "Chiratae Super Admin || Investor Addedit";
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Investing Firm
            </h5>
          </div>
          <Link to="/investors/list" state={{ listQuery }}>
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="investor_firm_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Firm Name :{" "}
                      </label>
                      <input
                        title="Firm Name"
                        placeholder="Enter firm name"
                        type="text"
                        name="investor_firm_name"
                        className="form-control store_input_field"
                        id="investor_firm_name"
                        value={ADDEDITDATA?.investor_firm_name}
                        onChange={handleChange}
                      />
                      {error.investor_firm_name ? (
                        <p style={{ color: "red" }}>{error.investor_firm_name}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="investor_description"
                      className="all_section_for_label_main_class"
                    >
                      Description :
                    </label>
                    <textarea
                      title="Enter description"
                      rows="5"
                      name="investor_description"
                      className="form-control store_input_field"
                      id="investor_description"
                      value={ADDEDITDATA?.investor_description}
                      onChange={handleChange}
                    />
                    {error.investor_description ? (
                      <p style={{ color: "red" }}>
                        {error.investor_description}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="rel_manager"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        Select
                        SPOC :
                      </label>
                      <select
                        className="form-control select_same_css"
                        name="rel_manager"
                        id="rel_manager"
                        onChange={handleChange}
                        // value={ADDEDITDATA?.rel_manager?._id || ""}
                      >
                        <option value="">Select SPOC</option>
                        {relManagersList.map((relManager, index) => (
                          <option
                            value={JSON.stringify(relManager)}
                            selected={
                              relManager?._id === ADDEDITDATA?.rel_manager?._id
                            }
                            key={index}
                          >
                            {relManager.name}
                          </option>
                        ))}
                      </select>
                      {error.rel_manager ? (
                        <p style={{ color: "red" }}>{error.rel_manager}</p>
                      ) : (
                        ""
                      )}
                    </div>
                </div>

                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Profile Image
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    // listType="picture"
                    onChange={handleImageChnage}
                    beforeUpload={beforeUpload}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG).
                  </p>
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default UserListEditPage;
